/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import AccountName from "../../../../components/_utils/AccountCreationComponents/AccountName";
import ContactDetails from "../../../../components/_utils/AccountCreationComponents/ContactDetails";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup";
import PrimaryStepper from "../../../../components/_utils/CommonSteppers/PrimaryStepper";
import SvgComponent from "../../../../components/_utils/SVGComponent";
import {
  editBeneficiary,
  resetEditBeneficiary,
} from "../../../../redux/features/accounts/BeneficiaryAccount/createAccount";
import { viewAccountDetail } from "../../../../redux/features/verifyPAN/verifyPAN";
import TEXT from "../../../../utils/globalText";
import Validation from "../../../../utils/validation";
import CommonLayout from "../../../../components/_utils/CommonLayout";

const BeneEditContact = (props) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [customErrors, setCustomErrors] = useState({});
  const [selectedValue, setSelectedValue] = useState("");
  const [updateActive, setUpdateActive] = useState(false);
  const [emailValidation, setEmailValidation] = useState(false);
  const [nextButtonEnabled, setNextButtonEnabled] = useState(true);
  const [openEditContactPop, setOpenEditContactPop] = useState(false);
  const [, setIsMobile] = useState(window.innerWidth <= 1024);
  const [accountNameValidation, setAccountNameValidation] = useState(true);
  const [contactNumberValidation, setContactNumberValidation] = useState(false);
  const [payload, setPayload] = useState({
    contact_no: "",
    email_id: "",
    account_name: "",
    legalName: "",
  });

  const { services, isLoading } = useSelector((state) => state.refreshToken);
  const { viewAccountDetailData, viewAccountDetailLoading } = useSelector(
    (state) => state.verify,
  );
  const { editBeneficiaryData } = useSelector(
    (state) => state.beneCreateAccount,
  );

  const handleBack = () => {
    if (!nextButtonEnabled) {
      setOpenEditContactPop(true);
    } else {
      navigate(-1);
    }
  };

  const handleRadioBtn = (event) => {
    setSelectedValue(event.target.value);
    handleUpdateLegalName(event.target.value);
  };
  const handleDivBtn = (value) => {
    setSelectedValue(value);
    handleUpdateLegalName(value);
  };

  const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]+$/;

  const modifyValue = (type, value) => {
    if (type === "name") {
      return value?.replace(/(\w)(\w*)/g, function (g1, g2) {
        return g1.toUpperCase() + g2.toLowerCase();
      });
    } else if (type === "gstin") {
      return value?.toUpperCase();
    } else if (type === "account_name") {
      return value;
    } else {
      return value.trim();
    }
  };

  const allowedValue = (name, value) => {
    if (name === "contact_no") return Validation.allowedContactNum(value);
    if (name === "email_id") return Validation.allowedEmail(value);

    return true;
  };

  const validateAndRecordError = (name, value) => {
    let errors = { ...customErrors };
    if (name === "email_id")
      errors = Validation.validateEmail(name, value, errors);
    if (name === "contact_no")
      errors = Validation.validateContactNum(name, value, errors);
    if (name === "account_name")
      errors = Validation.validateAccountName(name, value, errors);
    setCustomErrors(errors);
  };

  const checkAllValidations = () => {
    return contactNumberValidation && emailValidation;
  };

  const handleUpdateLegalName = (value) => {
    const beneficiaryData = viewAccountDetailData?.beneficiary_accounts?.[0];

    setPayload((prevPayload) => {
      if (value === "legalname") {
        return {
          ...prevPayload,
          account_name: beneficiaryData?.pan_legal_name || "",
        };
      }

      if (value === "customname") {
        const keepCurrent =
          prevPayload.account_name &&
          prevPayload.account_name.trim().length > 0 &&
          prevPayload.account_name.trim().toLowerCase() !==
            (beneficiaryData?.pan_legal_name || "").trim().toLowerCase();

        return {
          ...prevPayload,
          account_name: keepCurrent
            ? prevPayload.account_name
            : beneficiaryData?.name || "",
        };
      }

      return prevPayload;
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newValue = modifyValue(
      name,
      name !== "account_name" ? value.replace(/[^a-zA-Z0-9@.]/g, "") : value,
    );

    if (allowedValue(name, value)) {
      validateAndRecordError(name, newValue);
      setPayload((prevState) => ({
        ...prevState,
        [name]: newValue,
      }));

      if (value.trim() === "" && value.length === 1) {
        return;
      }
      if (name === "contact_no") {
        if (
          name === "contact_no" &&
          (newValue.length === 0 || newValue.length < 10)
        ) {
          setContactNumberValidation(false);
        } else {
          setContactNumberValidation(true);
        }
      }
      if (name === "email_id") {
        if (
          name === "email_id" &&
          (newValue.length === 0 || !emailRegex.test(newValue))
        ) {
          setEmailValidation(false);
        } else {
          setEmailValidation(true);
        }
      }
      if (name === "account_name") {
        if (name === "account_name" && newValue.length === 0) {
          setAccountNameValidation(false);
        } else {
          setAccountNameValidation(true);
        }
        if (
          newValue ===
          viewAccountDetailData?.beneficiary_accounts[0]?.pan_legal_name
        ) {
          setSelectedValue("legalname");
        }
      }
    }
  };

  useEffect(() => {
    if (!viewAccountDetailLoading && viewAccountDetailData?.status === true) {
      const beneficiaryData = viewAccountDetailData?.beneficiary_accounts[0];
      if (
        beneficiaryData?.contact_no !== payload.contact_no ||
        beneficiaryData?.email_id !== payload.email_id.toLowerCase() ||
        (beneficiaryData?.name.trim() !== payload.account_name.trim() &&
          payload.account_name.length !== 0)
      ) {
        if (
          !(checkAllValidations() && payload.email_id?.length !== 0) ||
          !(checkAllValidations() && payload.contact_no?.length !== 0) ||
          !payload.account_name.trim().length > 0
        ) {
          setNextButtonEnabled(true);
        } else {
          setNextButtonEnabled(false);
        }
      } else {
        setNextButtonEnabled(true);
      }
    }
  }, [payload.account_name, payload.contact_no, payload.email_id]);

  useEffect(() => {
    const fetchContactData = async () => {
      let response = await dispatch(viewAccountDetail({ id: id }));
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("*");
      }
    };
    fetchContactData();
  }, [dispatch, id, navigate]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);

  useEffect(() => {
    if (!viewAccountDetailLoading && viewAccountDetailData?.status === true) {
      const beneficiaryData = viewAccountDetailData?.beneficiary_accounts[0];

      if (beneficiaryData) {
        setPayload((prevPayload) => ({
          ...prevPayload,
          contact_no: beneficiaryData.contact_no,
          email_id: beneficiaryData.email_id,
          account_name: beneficiaryData.name,
          legalName: beneficiaryData.pan_legal_name,
        }));
      }
      if (beneficiaryData?.pan_legal_name === beneficiaryData?.name) {
        setSelectedValue("legalname");
      } else {
        setSelectedValue("customname");
      }
    }
  }, [viewAccountDetailData, viewAccountDetailLoading, dispatch]);

  useEffect(() => {
    setContactNumberValidation(
      Validation.allowedContactNum(payload.contact_no),
    );
    setEmailValidation(Validation.allowedEmail(payload.email_id));
  }, [payload.contact_no, payload.email_id]);

  useEffect(() => {
    if (customErrors["contact_no"]) setContactNumberValidation(false);
    if (!customErrors["contact_no"] && payload.contact_no?.length === 10)
      setContactNumberValidation(true);
    if (customErrors["email_id"]) setEmailValidation(false);
    if (
      !customErrors["email_id"] &&
      payload.email_id?.length > 0 &&
      emailRegex.test(payload.email_id)
    )
      setEmailValidation(true);
    if (customErrors["account_name"]) setAccountNameValidation(false);
    if (!customErrors["account_name"] && payload.account_name.length > 0)
      setAccountNameValidation(true);
  }, [customErrors]);

  useEffect(() => {
    if (editBeneficiaryData?.status === true) {
      const beneficiaryData = viewAccountDetailData?.beneficiary_accounts?.[0];
      const updatedFields = [];
   
      if (beneficiaryData?.contact_no !== payload.contact_no) {
        updatedFields.push("contact_no");
      }
      if (
        (beneficiaryData?.email_id || "").toLowerCase().trim() !==
        (payload.email_id || "").toLowerCase().trim()
      ) {
        updatedFields.push("email_id");
      }
      if (
        (beneficiaryData?.name || "").trim() !==
        (payload.account_name || "").trim()
      ) {
        updatedFields.push("account_name");
      }
      navigate(
        `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/contact_edit_success/${id}`,
        {
          state: {
            updatedFields:
              updatedFields.length > 0
                ? updatedFields
                : ["contact_no", "email_id", "account_name"],
          },
        },
      );
      dispatch(resetEditBeneficiary());
    }
  }, [editBeneficiaryData]);

  useEffect(() => {
    if (!isLoading && services != null) {
      if (services?.includes("BUAccount") || services?.includes("Admin")) {
      } else {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "BUAccount" },
        });
      }
    }
  }, [services, isLoading]);

  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Update",
      previousEnableBgColor: "var(--primary-nav-act)",
      previousDisableBgColor: "var(--primary-nav-act)",
      previousEnableTextColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      nextIsEnabled: !nextButtonEnabled && !updateActive,
      previousIsDisabled: updateActive,
      nextIsLoading: updateActive,
      nextLoaderNeeded: true,
      nextEnableBgColor: "var(--positive-act)",
      nextDisableBgColor: updateActive
        ? "var(--positive-act)"
        : "var(--text-disabled)",
      nextEnableTextColor: "var(--text-primary)",
      nextDisableTextColor: "var(--text-primary)",
      stepperText: "Contact details",
    },
  ];

  const handleEditUpdateAccount = async () => {
    if (updateActive) return;

    try {
      setUpdateActive(true);
      await dispatch(
        editBeneficiary({
          id: id,
          email: payload?.email_id?.toLowerCase(),
          contact_no: payload.contact_no,
          name: payload?.account_name,
          navigate,
        }),
      );
    } catch (error) {
      console.error("Update failed:", error);
    } finally {
      setUpdateActive(false);
    }
  };

  const handleConfirm = () => {
    navigate(
      `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${id}`,
    );
  };

  return (
    <>
      <div className="bg-primary-bg flex overflow-y-hidden flex-col h-full-height">
        <div
          className="flex flex-col items-center justify-start max-w-tab-width-normal mx-auto my-margin-base w-full bg-primary-nav rounded-b-border-radius-md"
          style={{
            overflow: !nextButtonEnabled && openEditContactPop ? "hidden" : "",
          }}
        >
          {!nextButtonEnabled && openEditContactPop && (
            <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
              <SmallPopup
                headerTitle={"Are you sure you want to leave this page?"}
                headerFontWeight="semibold"
                headerFontColor="text-primary"
                textSize="font-md"
                subtext="Leaving this page will exit you from current flow."
                btnOneText="Cancel"
                btnOneBtnType="button"
                btnOneEnabledBgColor="transparent"
                btnOneHandleFunction={() => setOpenEditContactPop(false)}
                btnOneOutLineColor="var(--text-primary)"
                btnOneEnabledTextColor="var(--text-primary)"
                btnOneIsDisabled={false}
                btnOneHoverOption="white"
                btnTwoText="Leave"
                btnTwoBtnType="button"
                btnTwoHandleFunction={handleConfirm}
                btnTwoEnabledBgColor="var(--text-primary)"
                btnTwoEnabledTextColor="var(--primary-bg)"
                btnTwoIsDisabled={false}
                btnTwoHoverOption="black"
              />
            </div>
          )}
          <div className="min-h-navbar-breadcrumb-height hidden Qmd:block"></div>
          <div className="flex justify-center items-end !bottom-bottom-base Qsmd:min-h-[calc(var(--stepper-height)+var(--icon-sm))] min-h-stepper-height Qsmd:bg-transparent rounded-t-border-radius-md Qmd:relative Qlg:bg-transparent bg-primary-nav rounded-b-border-radius-sm w-screen fixed Qsmd:top-top-base left-left-base z-z-index-overlay">
            <PrimaryStepper
              activeStep={0}
              handleForwardAction={handleEditUpdateAccount}
              handleBackwardAction={handleBack}
              dataArray={dataArray}
            />
          </div>
          <div className="fixed top-top-base left-left-base w-width-full z-z-index-header mt-margin-base">
            <div className="flex items-center h-mobile-create-header px-padding-md py-padding-sm">
              <div
                className="w-icon-sm h-icon-sm mr-margin-md cursor-pointer"
                onClick={handleBack}
              >
                <SvgComponent
                  url={ICONS?.ARROW_LEFT_WHITE}
                  height="var(--icon-sm)"
                  width="var(--icon-sm)"
                  color="var(--text-primary)"
                  alt="arrow left"
                />
              </div>

              <div className="flex flex-col gap-gap-xs">
                <p className="text-text-primary text-base">
                  {TEXT.EDIT_BENEFICIARY_ACCOUNT}
                </p>
                <p className="text-text-secondary text-xs">
                  {TEXT.ENTER_CONTACT_DETAILS}
                </p>
              </div>
            </div>
          </div>

          <div className="h-mobile-create-header block Qmd:hidden"></div>
        </div>

        <div className="h-full-height max-w-tab-width-normal mx-auto w-full pt-padding-md px-padding-md Qlg:px-padding-base flex-1">
          <CommonLayout>
            <AccountName
              handleChange={handleChange}
              accountNameValidation={accountNameValidation}
              accountName={payload.account_name}
              selectedValue={selectedValue}
              handleDivBtn={handleDivBtn}
              handleRadioBtn={handleRadioBtn}
              selectedRadioValue={selectedValue}
              legalName={payload?.legalName}
            />

            <ContactDetails
              handleChange={handleChange}
              contactNumberValidation={contactNumberValidation}
              emailValidation={emailValidation}
              contactNumber={payload.contact_no}
              emailId={payload.email_id}
              selectedValue={selectedValue}
            />
          </CommonLayout>
        </div>
      </div>
    </>
  );
};

export default BeneEditContact;
